import React from 'react';
import { connect } from 'react-redux';
import { InfoIcon, Text, Tooltip } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getDeviceBenefits } from "../../../../store/blocks/devices/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _DeviceBenefits = function _DeviceBenefits(_ref) {
  var className = _ref.className,
    data = _ref.data;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('benefits', className),
    "data-t-id": "components-DeviceBenefits"
  }, data.map(function (benefit) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('benefit'),
      key: benefit.text
    }, /*#__PURE__*/React.createElement(Text, {
      size: "size5-r-l"
    }, benefit.text), benefit.tooltip && /*#__PURE__*/React.createElement(Tooltip, {
      message: benefit.tooltip,
      position: "top",
      variant: "secondary"
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      fill: "#727281",
      size: "s",
      "data-t-id": "components-DeviceBenefits"
    })));
  }));
};
_DeviceBenefits.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    tooltip: PropTypes.string
  }))
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    data: getDeviceBenefits(state)
  };
};
export var DeviceBenefits = connect(mapStateToProps)(_DeviceBenefits);